// ═══════════════════════════════════════════════════════════════════════════
// CONSENTEMENT COOKIES — source unique, partagée par le bandeau et PostHog
// ═══════════════════════════════════════════════════════════════════════════
//
// Une seule décision, stockée UNE fois (localStorage `ck_consent`, la clé que
// portait déjà le bandeau local de la vitrine avant ce chantier — reprise pour
// qu'une décision existante d'un visiteur reste valable). Tout ce qui doit
// réagir à un changement de consentement (le chargement de PostHog) écoute
// l'évènement `aureus:consent-changed` plutôt que de relire le localStorage en
// boucle — R2 ter-C : la règle « un cookie non essentiel ne se charge qu'avec
// consentement » s'écrit une fois ici, tout le reste l'importe.

// Exportée pour qui a besoin de LIRE le nom de la clé (ex. tests) — mais les
// trois accès localStorage ci-dessous utilisent le littéral 'ck_consent' en
// dur, pas cette constante : __tests__/localstorage-scope-cliquet.test.js
// (M12, R10) balaie chaque accès localStorage à CLÉ LITTÉRALE du dépôt pour
// vérifier qu'aucune fuite multi-tenant ne s'y cache. Passer par une variable
// rendrait ces trois accès invisibles à cet audit — exactement l'inverse de
// ce qu'il vérifie.
export const CONSENT_KEY = 'ck_consent';
export const CONSENT_EVENT = 'aureus:consent-changed';

// 'accepted' | 'refused' | null (pas encore de décision)
export function getConsent() {
  if (typeof window === 'undefined') return null;
  try {
    const v = window.localStorage.getItem('ck_consent');
    if (v === '1' || v === 'accepted') return 'accepted';
    if (v === '0' || v === 'refused') return 'refused';
    return null;
  } catch {
    return null;
  }
}

export function setConsent(accepted) {
  if (typeof window === 'undefined') return;
  const value = accepted ? 'accepted' : 'refused';
  try { window.localStorage.setItem('ck_consent', value); } catch { /* stockage indisponible */ }
  try {
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { consent: value } }));
  } catch { /* environnement sans CustomEvent (ancien navigateur) */ }
}

// Efface la décision — utilisé par le lien « Gérer mes préférences cookies »
// (page privacy) pour rouvrir le bandeau sans avoir à vider le navigateur.
export function resetConsent() {
  if (typeof window === 'undefined') return;
  try { window.localStorage.removeItem('ck_consent'); } catch { /* stockage indisponible */ }
  try {
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { consent: null } }));
  } catch { /* environnement sans CustomEvent */ }
}
